var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconConfig = function SvgIconConfig(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.999,
    height: 16.002,
    viewBox: "0 0 15.999 16.002",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8798ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1879 -1282.998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-5977.732-13443H-5987a1,1,0,0,1-1-1,1,1,0,0,1,1-1h9.268a2,2,0,0,1,1.732-1,2,2,0,0,1,1.733,1H-5973a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-1.267a2,2,0,0,1-1.733,1A2,2,0,0,1-5977.732-13443Zm-4-6H-5987a1,1,0,0,1-1-1,1,1,0,0,1,1-1h5.269a1.993,1.993,0,0,1,1.729-1,1.994,1.994,0,0,1,1.732,1H-5973a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-5.266a2.005,2.005,0,0,1-1.736,1A2,2,0,0,1-5981.734-13449Zm-4-6H-5987a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1.27a2,2,0,0,1,1.729-1,2,2,0,0,1,1.729,1H-5973a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-9.268a2,2,0,0,1-1.732,1A2,2,0,0,1-5985.733-13455Z",
    transform: "translate(7867 14740.999)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconConfig, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-config.b63d045d.svg";
export { ForwardRef as ReactComponent };